// this is a placeholder for ===. Don't delete it.
import { ReactElement } from "react";
import styled from "styled-components";
import { ElementProps } from "../../functionalComponents/RenderPage";

const StyledStackDivider = styled.div``;

const StackDivider = function(): ReactElement<ElementProps> {
  return <StyledStackDivider className="stack-divider"></StyledStackDivider>;
};

export default StackDivider;
